import { useCallback, useState } from 'react';
import {
  createAsignacion,
  fetchAsignaciones,
  fetchAsignacionesOpciones,
  finalizarAsignacion,
} from '../services/asignaciones.service.js';

export function useAsignaciones() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSuccess = message => {
    setSuccess(message);
    setTimeout(() => setSuccess(null), 4000);
  };

  const list = useCallback(async (filters = {}) => {
    setLoading(true);
    setError(null);
    try {
      return await fetchAsignaciones(filters);
    } catch (err) {
      setError(err.message || 'No se pudo obtener el listado de asignaciones.');
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const loadOpciones = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      return await fetchAsignacionesOpciones();
    } catch (err) {
      setError(err.message || 'No se pudieron cargar los recursos.');
      return { choferes: [], vehiculos: [] };
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async input => {
    setLoading(true);
    setError(null);
    try {
      const result = await createAsignacion(input);
      handleSuccess('Asignación creada correctamente.');
      return result;
    } catch (err) {
      setError(err.message || 'No se pudo crear la asignación.');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const finalizar = useCallback(async (id, payload) => {
    setLoading(true);
    setError(null);
    try {
      const result = await finalizarAsignacion(id, payload);
      handleSuccess('Asignación finalizada.');
      return result;
    } catch (err) {
      setError(err.message || 'No se pudo finalizar la asignación.');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    success,
    list,
    loadOpciones,
    create,
    finalizar,
  };
}
